export interface ReportCardTheme {
  id: string;
  name: string;
  description: string;
  colors: {
    primary: string;
    primaryLight: string;
    secondary: string;
    accent: string;
    headerBorder: string;
    sectionBg: string;
    sectionTitle: string;
    globalGradeBg: string;
    globalGradeBorder: string;
    globalGradeText: string;
    studentInfoBg: string;
    criteriaBg: string;
    criteriaBorder: string;
    footerBorder: string;
    footerText: string;
    evaluationLabel: string;
  };
}

export const REPORT_CARD_THEMES: Record<string, ReportCardTheme> = {
  classic: {
    id: 'classic',
    name: 'Clásico',
    description: 'Diseño tradicional con azul institucional',
    colors: {
      primary: '#1e40af',
      primaryLight: '#e0e7ff',
      secondary: '#4b5563',
      accent: '#4338ca',
      headerBorder: '#1e40af',
      sectionBg: '#e0e7ff',
      sectionTitle: '#1e40af',
      globalGradeBg: '#f0f9ff',
      globalGradeBorder: '#1e40af',
      globalGradeText: '#1e40af',
      studentInfoBg: '#f3f4f6',
      criteriaBg: '#ffffff',
      criteriaBorder: '#e5e7eb',
      footerBorder: '#e5e7eb',
      footerText: '#9ca3af',
      evaluationLabel: '#4338ca',
    },
  },
  modern: {
    id: 'modern',
    name: 'Moderno',
    description: 'Diseño contemporáneo con tonos esmeralda',
    colors: {
      primary: '#059669',
      primaryLight: '#d1fae5',
      secondary: '#374151',
      accent: '#047857',
      headerBorder: '#059669',
      sectionBg: '#d1fae5',
      sectionTitle: '#065f46',
      globalGradeBg: '#ecfdf5',
      globalGradeBorder: '#059669',
      globalGradeText: '#059669',
      studentInfoBg: '#f0fdf4',
      criteriaBg: '#ffffff',
      criteriaBorder: '#d1fae5',
      footerBorder: '#d1fae5',
      footerText: '#9ca3af',
      evaluationLabel: '#047857',
    },
  },
  elegant: {
    id: 'elegant',
    name: 'Elegante',
    description: 'Diseño sobrio con tonos oscuros y dorados',
    colors: {
      primary: '#44403c',
      primaryLight: '#f5f5f4',
      secondary: '#57534e',
      accent: '#92400e',
      headerBorder: '#78716c',
      sectionBg: '#f5f5f4',
      sectionTitle: '#44403c',
      globalGradeBg: '#fefce8',
      globalGradeBorder: '#92400e',
      globalGradeText: '#92400e',
      studentInfoBg: '#fafaf9',
      criteriaBg: '#ffffff',
      criteriaBorder: '#e7e5e4',
      footerBorder: '#e7e5e4',
      footerText: '#a8a29e',
      evaluationLabel: '#92400e',
    },
  },
  minimalist: {
    id: 'minimalist',
    name: 'Minimalista',
    description: 'Diseño limpio con líneas finas en gris',
    colors: {
      primary: '#374151',
      primaryLight: '#f3f4f6',
      secondary: '#6b7280',
      accent: '#374151',
      headerBorder: '#d1d5db',
      sectionBg: '#f9fafb',
      sectionTitle: '#374151',
      globalGradeBg: '#f3f4f6',
      globalGradeBorder: '#6b7280',
      globalGradeText: '#374151',
      studentInfoBg: '#f9fafb',
      criteriaBg: '#ffffff',
      criteriaBorder: '#e5e7eb',
      footerBorder: '#e5e7eb',
      footerText: '#9ca3af',
      evaluationLabel: '#374151',
    },
  },
  royal: {
    id: 'royal',
    name: 'Real',
    description: 'Diseño distinguido en púrpura y dorado',
    colors: {
      primary: '#6d28d9',
      primaryLight: '#ede9fe',
      secondary: '#4c1d95',
      accent: '#7c3aed',
      headerBorder: '#6d28d9',
      sectionBg: '#ede9fe',
      sectionTitle: '#5b21b6',
      globalGradeBg: '#f5f3ff',
      globalGradeBorder: '#6d28d9',
      globalGradeText: '#6d28d9',
      studentInfoBg: '#faf5ff',
      criteriaBg: '#ffffff',
      criteriaBorder: '#ddd6fe',
      footerBorder: '#ddd6fe',
      footerText: '#a78bfa',
      evaluationLabel: '#7c3aed',
    },
  },
};

export function getThemeColors(themeId: string) {
  return REPORT_CARD_THEMES[themeId]?.colors ?? REPORT_CARD_THEMES.classic.colors;
}
